import { useEffect, useState } from "react";
import { Card, Col, Form, Input, Row, Space, Typography } from "antd";
import { noTrailingSpaceAllowedRule } from "utilities/generalUtility";
import Title from "antd/es/typography/Title";
import { FeatureList } from "./featureList/featureList";
import { PermissionList } from "./permissionList/permissionList";
import { usePermissionSelection } from "./hooks/usePermissionSelection";
import styles from "./createRolesPermission.module.scss";

export const RolePermissionsForm = ({
  form,
  groups,
  defaultSelectedIds = [],
  onFinish,
  onSelectionChange,
}) => {
  const [activeGroupKey, setActiveGroupKey] = useState(groups[0]?.key);

  const {
    selected,
    toggle,
    unmetFor,
    brokenFor,
    groupCount,
    groupStatus,
    permissionById,
    selectedIds,
    selectedCount,
    hasDependencyWarning,
  } = usePermissionSelection(groups, defaultSelectedIds);

  useEffect(() => {
    onSelectionChange({ selectedCount, hasDependencyWarning });
  }, [selectedCount, hasDependencyWarning, onSelectionChange]);

  const activeGroup = groups.find((g) => g.key === activeGroupKey) || groups[0];
  const totalPermissions = groups.reduce((n, g) => n + g.permissions.length, 0);

  const handleFinish = (values) => {
    onFinish({ name: values.name, permissions: selectedIds });
  };

  return (
    <Form layout="vertical" form={form} onFinish={handleFinish} style={{marginTop: "-16px"}}>
      <Space direction="vertical" size="middle" style={{ width: "100%" }}>
        <Card bordered={false} bodyStyle={{ padding: 0 }}>
          <div style={{ padding: 16 }}>
            <Title
              level={5}
              style={{ fontWeight: 600 }}
              className="text-primary"
            >
              Role Detail
            </Title>
            <Form.Item
              label="Role Name"
              name="name"
              rules={[
                { required: true, message: "Please enter role name!" },
                { min: 3, message: "Name must be at least 3 characters" },
                {
                  max: 150,
                  message: "Name cannot be longer than 150 characters",
                },
                noTrailingSpaceAllowedRule(),
              ]}
            >
              <Input placeholder="e.g. Senior Recruiter" />
            </Form.Item>
          </div>
        </Card>

        {activeGroup ? (
          <Row gutter={[16, 16]} wrap={false}>
            <Col flex="0 0 340px">
              <div className={styles.createRolesPermission__left}>
                <FeatureList
                  groups={groups}
                  activeKey={activeGroup.key}
                  onSelect={setActiveGroupKey}
                  groupCount={groupCount}
                  groupStatus={groupStatus}
                />
                <div className={styles.createRolesPermission__summary}>
                  <strong>{selectedCount}</strong> of{" "}
                  <strong>{totalPermissions}</strong> selected
                </div>
              </div>
            </Col>
            <Col flex={1}>
              <div className={styles.createRolesPermission__right}>
                <PermissionList
                  group={activeGroup}
                  permissionById={permissionById}
                  selected={selected}
                  unmetFor={unmetFor}
                  brokenFor={brokenFor}
                  onToggle={toggle}
                />
              </div>
            </Col>
          </Row>
        ) : (
          <Typography.Text type="secondary">
            No permissions available.
          </Typography.Text>
        )}
      </Space>
    </Form>
  );
};
